var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5V3.5C7.5 2.11929 6.38071 1 5 1C3.61929 1 2.5 2.11929 2.5 3.5V4.5M5 6.75V7.75M3.4 10H6.6C7.44008 10 7.86012 10 8.18099 9.83651C8.46323 9.6927 8.6927 9.46323 8.83651 9.18099C9 8.86012 9 8.44008 9 7.6V6.9C9 6.05992 9 5.63988 8.83651 5.31901C8.6927 5.03677 8.46323 4.8073 8.18099 4.66349C7.86012 4.5 7.44008 4.5 6.6 4.5H3.4C2.55992 4.5 2.13988 4.5 1.81901 4.66349C1.53677 4.8073 1.3073 5.03677 1.16349 5.31901C1 5.63988 1 6.05992 1 6.9V7.6C1 8.44008 1 8.86012 1.16349 9.18099C1.3073 9.46323 1.53677 9.6927 1.81901 9.83651C2.13988 10 2.55992 10 3.4 10Z",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchLock);
export default __webpack_public_path__ + "static/media/SwitchLock.df67418bbcebca3c563498c08ca77555.svg";
export { ForwardRef as ReactComponent };